module.exports = __webpack_public_path__ + "img/icon_map_188_on_101.eba25d3e.png";